import { ConfigurationProvider } from '../configuration/ConfigurationProvider';
import { IdentityProvider } from '../identity/IdentityProvider';
import { RealtimeProvider } from '../../../features/logs/services/RealtimeProvider';
import axios from "axios";
import { setupInterceptorsTo } from '../http/Interceptors';

export class Startup {
    static async Run( app: () => void) {

        await ConfigurationProvider.init();
        setupInterceptorsTo(axios)

        // identity first: the realtime connection asks it for the access token the hub requires
        await IdentityProvider.init();
        RealtimeProvider.init();

        app();
    }
}
